const modeMap = {
  r: 2,
  w: 1,
};

export default {
  pass: (user, permissions) => {
    let { group, privileges } = user;

    group = parseInt(group);

    let access = true;

    if (!permissions) {
      return access;
    }

    permissions.forEach((permission) => {
      const ps = permission.split(":");

      const p = ps[0];
      const o = ps.length > 1 ? ps[1] : null;

      switch (p) {
        case "group": {
          // o = {operator},{group}
          let os = o.split(",");

          if (os.length == 1) {
            access = group == parseInt(os[0]);
            break;
          }

          let [operator, match] = os;
          match = parseInt(match);

          switch (operator) {
            case ">":
              access = group > match;
              break;
            case "<":
              access = group < match;
              break;
            case ">=":
              access = group >= match;
              break;
            case "<=":
              access = group <= match;
              break;
            case "!=":
              access = group != match;
              break;
            default:
              throw "權限定義錯誤['group'] => " + operator;
          }
          break;
        }
        case "notSub": {
          access = user.isSub != true;
          break;
        }
        // privilege:{item},{mode=r}
        case "privilege": {
          const os = o.split(",");
          const item = os[0];

          // 未定義權限或不具有該權限項目
          if (!privileges || !privileges[item]) {
            access = false;
            break;
          }

          const mode = os.length > 1 ? os[1] : "r";
          const b = modeMap[mode];
          let status = privileges[item];

          status = parseInt(status);

          access = (status & b) == b;
          break;
        }
        default:
          throw "權限定義錯誤: " + permission;
      }

      if (!access) {
        return false;
      }
    });

    return access;
  },
};
